import useClientAccountProfileQuery from '../queries/useClientAccountProfileQuery';
import useQueryParams from './useQueryParams';

export default function useCheckMyProfile(
  options?: Parameters<typeof useClientAccountProfileQuery>[0],
) {
  const { id } = useQueryParams();

  const { data: profile, isLoading } = useClientAccountProfileQuery({
    enabled: Boolean(id),
    ...options,
  });

  return {
    isMe: Number(profile?.id) === Number(id),
    isLoading,
  };
}
